import { useContext as useContextWithSelector } from 'use-context-selector';

import { CatalogDataContextWithSelector } from './CatalogDataContext.types';

/**
 * @deprecated use the explicit context selectors to avoid unnecessary re-render
 */
export const useCatalogDataContext = () => {
  return useContextWithSelector(CatalogDataContextWithSelector);
};
